import { OTPInputProps } from '$elements/OTPInput'

type UseTOTPBlockOptions = {
  otpInput: OTPInputProps
  title: string
  description: string
}

export const useTOTPBlock = (props: UseTOTPBlockOptions) => props

export default useTOTPBlock
